// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__12e_v","range":"MonthRangeSwitch_range__3m1tA","disabled":"MonthRangeSwitch_disabled__1lWsd"};